import { get } from 'lodash';
import { SUBMIT_KAPITI_TRANSACTIONS_SUCCESS } from './actions';

const initialState = {
	transactions: [],
};

const kapitiTransactions = (state = initialState, action) => {
	switch (action.type) {
		case SUBMIT_KAPITI_TRANSACTIONS_SUCCESS: {
			const transactions = get(action, 'payload.transaction_info', []);
			return { ...state, transactions };
		}
		default:
			return state;
	}
};

export default kapitiTransactions;
